export default "__VITE_ASSET__0qGKvNPE__"